"use strict";
exports.__esModule = true;
var basic_chart_component_1 = require("../../../../basic-component/basic-chart.component");
var config_1 = require("../../../../../../config");
angular.module('smartorg.r6.acts.image').directive("rangalImage", ["$location", function ($location) {
        function getTimestampMode(portfolioName, dbTimestampMode) {
            var sessionSettingString = localStorage.getItem('PortfolioConfig');
            if (sessionSettingString) {
                var sessionSettings = JSON.parse(sessionSettingString)[portfolioName];
                if (sessionSettings && sessionSettings.timestamp) {
                    return sessionSettings.timestamp.timestampMode;
                }
            }
            return dbTimestampMode;
        }
        return {
            restrict: 'E',
            template: require('../../template/image.html'),
            scope: {
                menu: '='
            },
            link: function (scope) {
                scope.$on('command:IMAGE', function (event, args) {
                    scope.actionMenuItem = args.actionMenuItem;
                    scope.nodeName = args.config.data.nodeName;
                    var imageUrlList = args.config.data.imageUrlList;
                    var shadowTitleList = args.config.data.shadowTitleList;
                    var ShadowImageUrlList = args.config.data.ShadowImageUrlList;
                    scope.fitToScreen = args.config.data.fitToScreen;
                    var timestampMode = getTimestampMode(args.treeName, args.config.data.timestampMode);
                    scope.timestamp = timestampMode === 'lastRecalc' ? basic_chart_component_1.getDate(args.nodeLastRecalc) : basic_chart_component_1.getDate();
                    // var prefix = $location.host() == "localhost" ?
                    //     "https://localhost" : "";
                    var prefix = config_1.BACKEND_DOMAIN;
                    if (imageUrlList && imageUrlList.length) {
                        scope.imageUrl = prefix + imageUrlList[0];
                    }
                    scope.shadowTitle =
                        shadowTitleList && shadowTitleList.length ?
                            shadowTitleList[0] : undefined;
                    scope.ShadowImageUrl =
                        ShadowImageUrlList && ShadowImageUrlList.length ?
                            prefix + ShadowImageUrlList[0] : undefined;
                    scope.currentTimeValue = new Date().getTime();
                    scope.menu = menu;
                    scope.$apply();
                });
                var menu = [{
                        'name': 'Export',
                        'items': [{
                                'name': 'Chart',
                                'callback': function () {
                                    window.open(scope.imageUrl);
                                }
                            }]
                    }];
            }
        };
    }]);
//# sourceMappingURL=image-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/image/app/js/plumbing/image-directive.js